import React from 'react';
import AssistantBotRow from '../shells/AssistantBotRow';
import UserReplyRow from '../shells/UserReplyRow';
import type { useEmploymentContractFlow } from './useEmploymentContractFlow';

type Flow = ReturnType<typeof useEmploymentContractFlow>;

export default function EmploymentContractChatThread({ flow }: { flow: Flow }) {
  const undoLabel = flow.t('submitDocuments.chat.undo');

  return (
    <>
      {flow.committed.map((c, idx) => (
        <React.Fragment key={`${c.stepId}-${idx}`}>
          <AssistantBotRow>{c.label}</AssistantBotRow>
          <UserReplyRow
            displayText={c.displayValue}
            showUndo={false}
            onUndo={() => undefined}
            undoLabel={undoLabel}
          />
        </React.Fragment>
      ))}
      {flow.awaitingAgree && (
        <AssistantBotRow animateIn>{flow.msg('steps.agree')}</AssistantBotRow>
      )}
      {flow.materialsDeclined && (
        <AssistantBotRow animateIn>{flow.msg('declinedMessage')}</AssistantBotRow>
      )}
    </>
  );
}
